module.exports = __webpack_public_path__ + "static/media/detectDataImage6_en.9af27365.png";